import { ReactComponent as KeyIcon } from '../icons/main_menu/api_keys.svg';
import { ReactComponent as IntegrationsIcon } from '../icons/main_menu/integrations.svg';
import { ReactComponent as ImporIcon } from '../icons/main_menu/import.svg';

import XmlPage from "./XmlImportPage";

const exports = {
  Page: XmlPage,
  Icon: ImporIcon,
  KeyIcon: KeyIcon,
  IntegrationsIcon: IntegrationsIcon,
};
export default exports;
